import { get } from 'services/api/base';

import { ProductSingleDetailed } from './types-get-one-product';

export function getOne({ productId, posId }: { productId: string; posId?: string }): Promise<ProductSingleDetailed> {
  const posIdParam = posId ? `?pos=${posId}` : '';
  return get(`v5/products/${productId}${posIdParam}`).json<ProductSingleDetailed>();
}
